import React, { useRef,useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {  Bell, Search, MessageSquare, ChevronDown, User, Plus,
  X, ChevronRight, Calendar, DollarSign,CreditCard, Sparkles,UserPlus} from 'lucide-react';
import axios from 'axios';
import config from '../config/config';
import BottomBar from '../components/BottomBar'; 
function TopBar() {
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);
  const navigate = useNavigate();
  const [showNotifications, setShowNotifications] = useState(false);
  const [notificationCount,setNotificationCount] = useState(0);
  const [notifications, setNotifications]=useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [students, setStudents] = useState([]);
  const [terms, setTerms] = useState([]);
  const [username, setUser] = useState('');
  const [useraccount_type, setUserAccount] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [showSearchDropdown, setShowSearchDropdown] = useState(false);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [showExpenseModal, setShowExpenseModal] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [availableInvoiceItems, setAvailableInvoiceItems] = useState([]);
  const [availableExpenseItems, setAvailableExpenseItems] = useState([]);

  const [invoiceData, setInvoiceData] = useState({
    studentId: '',
    termId: '',
    invoiceDate: startDate || '',
    dueDate: endDate || '',
    items: [{ description: '', amount: '', taxPercentage: 0 }],
    note: '',
  });

  const [expenseData, setExpenseData] = useState({
    studentId: '',
    termId: '',
    invoiceDate: '',
    dueDate: '',
    items: [{ description: '', amount: '', taxPercentage: 0 }],
    note: '',
  });

  const fetchStudents = async () => {
    const token = localStorage.getItem('token');
    try {
      const res = await axios.get(`${config.API_URL}/api/pullstudents`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      });
      setStudents(res.data.students);
      setUser(res.data.user);
      setUserAccount(res.data.account);
    } catch (err) {
      console.error('Error fetching students:', err);
    }
  };

   const pullTermDates = async (termId) => {
      const token = localStorage.getItem('token');
    try {
      const res = await axios.get(`${config.API_URL}/api/pullTermDates/`+termId, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      });
     setStartDate(res.data.startDate);
     setEndDate(res.data.endDate);
    } catch (err) {
      console.error('Error fetching students:', err);
    }
  };

  const fetchTerms = async () => {
    const token = localStorage.getItem('token');
    try {
      const res = await axios.get(`${config.API_URL}/api/pullterms`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      });
      setTerms(res.data.terms || res.data || []);
      setNotifications(res.data.notifications || res.data || []);
      setNotificationCount(res.data.notificationCount || res.data || []);
    } catch (err) {
      console.error('Error fetching terms:', err);
    }
  };

  const fetchInvoiceItems = async () => {
    const token = localStorage.getItem('token');
    try {
      const res = await axios.get(`${config.API_URL}/api/pullproductitems/Fee`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      });
      setAvailableInvoiceItems(res.data.invoiceItems || res.data || []);
    } catch (err) {
      console.error('Error fetching invoice items:', err);
    }
  };

  const fetchExpenseItems = async () => {
    const token = localStorage.getItem('token');
    try {
      const res = await axios.get(`${config.API_URL}/api/pullproductitems/Expense`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      });
      setAvailableExpenseItems(res.data.invoiceItems || res.data || []);
    } catch (err) {
      console.error('Error fetching expense items:', err);
    }
  };

  useEffect(() => {
    fetchStudents();
    fetchTerms();
    fetchInvoiceItems();
    fetchExpenseItems();
  }, []);

  const onSignOut = () => {
    localStorage.removeItem('token');
    navigate('/');
  };

  

  const handleAddItem = () => {
    setInvoiceData({
      ...invoiceData,
      items: [...invoiceData.items, { description: '', amount: '', taxPercentage: 0 }],
    });
  };

  const handleExpenseAddItem = () => {
    setExpenseData({
      ...expenseData,
      items: [...expenseData.items, { description: '', amount: '', taxPercentage: 0 }],
    });
  };

  const handleAddPredefinedItem = (predefinedItem) => {
    const newItem = {
      description: predefinedItem.description || predefinedItem.name,
      amount: predefinedItem.amount || predefinedItem.price || '',
      taxPercentage: predefinedItem.taxPercentage || predefinedItem.tax || 0,
    };
    setInvoiceData({
      ...invoiceData,
      items: [...invoiceData.items, newItem],
    });
  };

  const handleExpenseAddPredefinedItem = (predefinedItem) => {
    const newItem = {
      description: predefinedItem.description || predefinedItem.name,
      amount: predefinedItem.amount || predefinedItem.price || '',
      taxPercentage: predefinedItem.taxPercentage || predefinedItem.tax || 0,
    };
    setExpenseData({
      ...expenseData,
      items: [...expenseData.items, newItem],
    });
  };

  const handleRemoveItem = (index) => {
    const newItems = [...invoiceData.items];
    newItems.splice(index, 1);
    setInvoiceData({ ...invoiceData, items: newItems });
  };

  const handleItemChange = (index, field, value) => {
    const newItems = [...invoiceData.items];
    newItems[index][field] = value;
    setInvoiceData({ ...invoiceData, items: newItems });
  };

  const handleExpenseRemoveItem = (index) => {
    const newItems = [...expenseData.items];
    newItems.splice(index, 1);
    setExpenseData({ ...expenseData, items: newItems });
  };

  const handleExpenseItemChange = (index, field, value) => {
    const newItems = [...expenseData.items];
    newItems[index][field] = value;
    setExpenseData({ ...expenseData, items: newItems });
  };

  const calculateTotals = () => {
    const subtotal = invoiceData.items.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);
    const totalTax = invoiceData.items.reduce(
      (sum, item) => sum + (parseFloat(item.amount || 0) * parseFloat(item.taxPercentage || 0)) / 100,
      0
    );
    const total = subtotal + totalTax;
    return {
      subtotal: subtotal.toFixed(2),
      totalTax: totalTax.toFixed(2),
      total: total.toFixed(2),
    };
  };

  const calculateExpenseTotals = () => {
    const subtotal = expenseData.items.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);
    const totalTax = expenseData.items.reduce(
      (sum, item) => sum + (parseFloat(item.amount || 0) * parseFloat(item.taxPercentage || 0)) / 100,
      0
    );
    const total = subtotal + totalTax;
    return {
      subtotal: subtotal.toFixed(2),
      totalTax: totalTax.toFixed(2),
      total: total.toFixed(2),
    };
  };

  const totals = calculateTotals();
  const expensetotals = calculateExpenseTotals();

  const handleExpenseSubmit = async () => {
    const payload = {
      ...expenseData,
      totalAmount: parseFloat(expensetotals.total),
      totalTax: parseFloat(expensetotals.totalTax),
    };

    try {
      const token = localStorage.getItem('token');
       // 1. Fetch CSRF cookie
      //console.log('Fetching CSRF cookie...');
      const csrfResponse = await axios.get(`${config.API_URL}/sanctum/csrf-cookie`, {
        withCredentials: true,
      });
      //console.log('CSRF Response:', csrfResponse);

      // 2. Get CSRF token
      const xsrfToken = getCookie('XSRF-TOKEN');
      //console.log('XSRF Token:', xsrfToken);
      if (!xsrfToken) {
        throw new Error('CSRF token not found');
      }
      await axios.post(`${config.API_URL}/api/addNewExpense`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
          Accept: 'application/json',
          'X-XSRF-TOKEN': xsrfToken,
        },
        withCredentials: true,
      });
      setShowExpenseModal(false);
      window.location.assign('/expenses');
    } catch (error) {
      console.error('Error saving expense:', error.response?.data || error.message);
    }
  };

  // Utility function to get cookie
  const getCookie = (name) => {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    if (match) return decodeURIComponent(match[2]);
    return null;
  };

  const handleSubmit = async () => {
    const payload = {
      ...invoiceData,
      totalAmount: parseFloat(totals.total),
      totalTax: parseFloat(totals.totalTax),
    };

    try {
       const token = localStorage.getItem('token');
       // 1. Fetch CSRF cookie
      //console.log('Fetching CSRF cookie...');
      const csrfResponse = await axios.get(`${config.API_URL}/sanctum/csrf-cookie`, {
        withCredentials: true,
      });
      //console.log('CSRF Response:', csrfResponse);

      // 2. Get CSRF token
      const xsrfToken = getCookie('XSRF-TOKEN');
      //console.log('XSRF Token:', xsrfToken);
      if (!xsrfToken) {
        throw new Error('CSRF token not found');
      }
      await axios.post(`${config.API_URL}/api/addNewInvoice`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
          Accept: 'application/json',
          'X-XSRF-TOKEN': xsrfToken,
        },
        withCredentials: true,
      });
      setShowInvoiceModal(false);
      window.location.assign('/invoices');
    } catch (error) {
      console.error('Error saving invoice:', error.response?.data || error.message);
    }
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
    setShowSearchDropdown(true);
    const filtered = students.filter((s) => s.name.toLowerCase().includes(query.toLowerCase()));
    setFilteredStudents(filtered);
  };

  const handleClickOutside = () => {
    setShowSearchDropdown(false);
    setShowNotifications(false);
    setShowUserMenu(false);
  };

  return (
    <>
      <header className="bg-white border-b border-gray-100 shadow-sm sticky top-0 z-40">
        <div className="max-w-full mx-auto">
          <div className="flex items-center justify-between px-4 lg:px-8 py-4">
            {/* Branding */}
            <div className="flex items-center space-x-3">
              <div className="flex items-center">
              <img
                  src="https://joharischool.co.ke/wp-content/uploads/2022/01/download.png"
                  className="rounded"
                  style={{ width: '70px', height: '60px' }}
                  alt="Johari School Logo"
                />
                <span className="font-bold text-2xl bg-clip-text text-transparent bg-gradient-to-r from-violet-600 to-indigo-600">
                 
                </span>
                <span className="font-bold text-2xl text-gray-800"> Johari School</span>
              </div>
            </div>

            {/* Search */}
            <div className="hidden md:block relative max-w-md w-full mx-6">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Search size={16} className="text-gray-400" />
              </div>
            
              {showSearchDropdown && searchQuery && (
                <div className="absolute z-10 bg-white border border-gray-100 rounded-xl shadow-lg mt-1 max-h-60 overflow-auto w-full">
                  <div className="p-2">
                    <h4 className="text-xs font-medium text-gray-500 mb-1 px-2">RESULTS</h4>
                    {filteredStudents.map((student) => (
                      <div
                        key={student.id}
                        onClick={() => navigate(`/students/${student.id}/invoices`)}
                        className="p-2 hover:bg-indigo-50 rounded-lg cursor-pointer text-sm flex items-center"
                      >
                        <div className="h-8 w-8 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 mr-3">
                          {student.name.charAt(0)}
                        </div>
                        <div>
                          <p className="font-medium text-gray-800">{student.name}</p>
                        </div>
                      </div>
                    ))}
                    {filteredStudents.length === 0 && (
                      <div className="p-2 text-gray-500 text-sm">No students found.</div>
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* Actions */}
            <div className="flex items-center space-x-2 md:space-x-5">
              {/* Mobile Search */}
            
           

              {/* Mobile Add Button */}
              <button
                onClick={() => setShowInvoiceModal(true)}
                className="md:hidden flex items-center justify-center h-10 w-10 rounded-full bg-gradient-to-r from-indigo-600 to-violet-600 text-white shadow-sm shadow-indigo-200"
              >
                <Plus size={18} />
              </button>

              {/* Notifications */}
              <div className="relative">
               
                 {showNotifications && (
                    <div className="absolute right-0 mt-2 w-80 md:w-96 bg-white rounded-xl shadow-xl border border-gray-100 z-50 overflow-hidden">
                      <div className="flex items-center justify-between p-4 border-b border-gray-100">
                        <h4 className="font-semibold text-gray-800">Notifications</h4>
                        <button className="text-xs text-indigo-600 hover:text-indigo-800 font-medium">Mark all as read</button>
                      </div>
                      <div className="max-h-80 overflow-y-auto">
                        {/* Sample Notifications */}
                      {notifications.map((notification) => (
                 
              
                        <div className="p-4 hover:bg-indigo-50 border-l-4 border-indigo-500 transition-all" onClick={() => navigate(`/students/${notification.invoice_id}/viewreceipt`)}>
                          <div className="flex items-start">
                            <div className="h-9 w-9 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 mr-3">
                              <DollarSign size={16} />
                            </div>
                            <div>
                              <p className="font-medium text-gray-800">{notification.title}</p>
                              <p className="text-sm text-gray-500">{notification.message}</p>
                              <p className="text-xs text-gray-400 mt-1">{notification.created_at}</p>
                            </div>
                          </div>
                        </div>
                        ))}
                        
                      </div>
                      <div className="p-3 bg-gray-50 border-t border-gray-100">
                        <button onClick={() => navigate(`/payments`)} className="w-full text-center text-sm text-indigo-600 font-medium hover:text-indigo-800 flex items-center justify-center">
                          View All Payments <ChevronRight size={14} className="ml-1" />
                        </button>
                      </div>
                    </div>
                  )}
              </div>

              {/* User */}
              <div className="relative ml-1">
                <div
                  onClick={() => setShowUserMenu(!showUserMenu)}
                  className="flex items-center space-x-3 cursor-pointer p-1 rounded-full hover:bg-gray-50 transition-all"
                >
                  <div className="h-10 w-10 rounded-full bg-gradient-to-br from-violet-600 to-indigo-600 flex items-center justify-center text-white shadow-sm">
                    <span className="font-medium">{username[0]}</span>
                  </div>
                  <div className="hidden lg:block pr-1">
                    <p className="text-sm font-medium text-gray-800">{username}</p>
                    <p className="text-xs text-gray-500">{useraccount_type}</p>
                  </div>
                  <ChevronDown size={16} className="hidden lg:block text-gray-400" />
                </div>

                {showUserMenu && (
                  <div className="absolute right-0 mt-2 w-60 bg-white rounded-xl shadow-xl border border-gray-100 z-50 overflow-hidden">
                    <div className="py-2">
                      <button className="w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-indigo-50 hover:text-indigo-600 flex items-center">
                        <User size={16} className="mr-3" /> Your Profile
                      </button>
                    </div>
                    <div className="py-2 border-t border-gray-100">
                      <button
                        onClick={onSignOut}
                        className="w-full text-left px-4 py-2.5 text-sm text-red-600 hover:bg-red-50 font-medium flex items-center"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4 mr-3"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013 3v1"
                          />
                        </svg>
                        Logout
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </header>
        <BottomBar  />
        

      {/* Click away overlay */}
      {(showNotifications || showSearchDropdown || showUserMenu) && (
        <div className="fixed inset-0 z-30 bg-transparent" onClick={handleClickOutside}></div>
      )}

      {/* Expense Modal */}
      {showExpenseModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white w-full max-w-4xl p-6 rounded-xl shadow-xl relative overflow-hidden max-h-screen overflow-y-auto">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-indigo-600 to-violet-600"></div>
            <button
              onClick={() => setShowExpenseModal(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors rounded-full hover:bg-gray-100 p-1"
            >
              <X size={20} />
            </button>

            <h2 className="text-xl font-semibold mb-5 text-gray-800">New Expense</h2>

            {/* Dates */}
            <div className="flex space-x-4 mb-4">
              <div className="w-1/2">
                <label className="block text-sm font-medium text-gray-700 mb-1">Bill Date:</label>
                <input
                  type="date"
                  value={expenseData.invoiceDate}
                  onChange={(e) => setExpenseData({ ...expenseData, invoiceDate: e.target.value })}
                  className="w-full border border-gray-300 rounded-lg p-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none bg-gray-50"
                />
              </div>
              <div className="w-1/2">
                <label className="block text-sm font-medium text-gray-700 mb-1">Valid Till:</label>
                <input
                  type="date"
                  value={expenseData.dueDate}
                  onChange={(e) => setExpenseData({ ...expenseData, dueDate: e.target.value })}
                  className="w-full border border-gray-300 rounded-lg p-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none bg-gray-50"
                />
              </div>
            </div>

            {/* Available Expense Items */}
            {availableExpenseItems.length > 0 && (
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">Quick Add Items</label>
                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-4 rounded-lg border border-blue-200">
                  <div className="flex flex-wrap gap-2">
                    {availableExpenseItems.map((item, index) => (
                      <button
                        key={index}
                        onClick={() => handleExpenseAddPredefinedItem(item)}
                        className="inline-flex items-center px-3 py-1.5 bg-white border border-blue-200 text-blue-700 text-sm rounded-lg hover:bg-blue-50 hover:border-blue-300 transition-colors shadow-sm"
                      >
                        <Plus size={14} className="mr-1" />
                        {item.name} - KSH {item.price}
                        {(item.taxPercentage || item.tax) && (
                          <span className="ml-1 text-xs text-blue-500">({item.taxPercentage || item.tax}% tax)</span>
                        )}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {/* Expense Items */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">Bill Items</label>
              <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                <div className="grid grid-cols-12 gap-2 mb-2 text-xs font-medium text-gray-500 px-2">
                  <div className="col-span-5">DESCRIPTION</div>
                  <div className="col-span-5">AMOUNT (KSH)</div>
                {/*  <div className="col-span-3">TAX (%)</div>*/}
                  <div className="col-span-1"></div>
                </div>

              {Array.isArray(expenseData.items) && expenseData.items.length > 0  && (
  <div>
    {expenseData.items
      .filter(item => item.description !== '')
      .map((item, indexd) => (

      <div key={indexd} className="grid grid-cols-12 gap-2 mb-2">
        <input
          placeholder="Item description"
          value={item.description || ''}
          onChange={(e) => handleExpenseItemChange(indexd, 'description', e.target.value)}
          className="col-span-5 border border-gray-300 p-2.5 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none bg-white"
        />
        <input
          placeholder="0.00"
          type="number"
          step="0.01"
          value={item.amount || ''}
          onChange={(e) => handleExpenseItemChange(indexd, 'amount', e.target.value)}
          className="col-span-3 border border-gray-300 p-2.5 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none bg-white"
        />
      {/*  <input
          placeholder="0.0"
          type="number"
          step="0.1"
          value={item.taxPercentage || ''}
          onChange={(e) => handleExpenseItemChange(index, 'taxPercentage', e.target.value)}
          className="col-span-3 border border-gray-300 p-2.5 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none bg-white"
        />*/}
        <button
          onClick={() => handleExpenseRemoveItem(indexd)}
          className="col-span-1 flex items-center justify-center text-red-500 hover:text-red-700 hover:bg-red-50 rounded-lg transition-colors"
        >
          <X size={16} />
        </button>
      </div>
    ))}
  </div>
)}

              {/*  <button
                  onClick={handleExpenseAddItem}
                  className="mt-2 text-sm text-indigo-600 hover:text-indigo-800 font-medium flex items-center"
                >
                  <Plus size={16} className="mr-1" /> Add Custom Item
                </button>*/}
              </div>
            </div>

            {/* Expense Totals */}
            <div className="mb-4">
              <div className="bg-gradient-to-r from-indigo-50 to-violet-50 p-4 rounded-lg border border-indigo-200">
                <h4 className="text-sm font-medium text-gray-700 mb-3">Expense Summary</h4>
                <div className="space-y-2">
                  <div className="flex justify-between items-center text-sm">
                    <span className="text-gray-600">Subtotal:</span>
                    <span className="font-medium">KSH {expensetotals.subtotal}</span>
                  </div>
                  <div className="flex justify-between items-center text-sm">
                    <span className="text-gray-600">Total Tax:</span>
                    <span className="font-medium">KSH {expensetotals.totalTax}</span>
                  </div>
                  <div className="border-t border-indigo-200 pt-2">
                    <div className="flex justify-between items-center text-base font-semibold">
                      <span className="text-gray-800">Total:</span>
                      <span className="text-indigo-600">KSH {expensetotals.total}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Notes */}
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">Notes</label>
              <textarea
                placeholder="Add any additional notes here..."
                value={expenseData.note}
                onChange={(e) => setExpenseData({ ...expenseData, note: e.target.value })}
                className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none bg-gray-50 min-h-20"
              ></textarea>
            </div>

            {/* Action Buttons */}
            <div className="flex justify-end space-x-3">
              <button
                onClick={() => setShowExpenseModal(false)}
                className="px-4 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 font-medium transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleExpenseSubmit}
                className="px-6 py-2.5 bg-gradient-to-r from-indigo-600 to-violet-600 text-white rounded-lg hover:from-indigo-700 hover:to-violet-700 font-medium shadow-sm shadow-indigo-200 hover:shadow-md transition-all"
              >
                Save Bill
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Invoice Modal */}
      {showInvoiceModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white w-full max-w-4xl p-6 rounded-xl shadow-xl relative overflow-hidden max-h-screen overflow-y-auto">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-indigo-600 to-violet-600"></div>
            <button
              onClick={() => setShowInvoiceModal(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors rounded-full hover:bg-gray-100 p-1"
            >
              <X size={20} />
            </button>

            <h2 className="text-xl font-semibold mb-5 text-gray-800">Generate Fee</h2>

            {/* Select Student 
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">Student</label>
              <select
                value={invoiceData.studentId}
                onChange={(e) => setInvoiceData({ ...invoiceData, studentId: e.target.value })}
                className="w-full border border-gray-300 rounded-lg p-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none bg-gray-50"
              >
                <option value="">Select Grade</option>
                <option value="all">ALL Grades</option>
                {students.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.name}
                  </option>
                ))}
              </select>
            </div>
*/}
            {/* Select Term */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">Term</label>
              <select
                value={invoiceData.termId}
                onChange={(e) => {pullTermDates(e.target.value); setInvoiceData({ ...invoiceData, termId: e.target.value })}}
                className="w-full border border-gray-300 rounded-lg p-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none bg-gray-50"
              >
                <option value="">Select Term</option>
                {terms.map((term) => (
                  <option key={term.id} value={term.id}>
                    {term.term}
                  </option>
                ))}
              </select>
            </div>

            {/* Dates */}
            <div className="flex space-x-4 mb-4">
              <div className="w-1/2">
                <label className="block text-sm font-medium text-gray-700 mb-1">Opening Date</label>
                <input
                  type="date"
                  value={startDate || invoiceData.invoiceDate }
                  onChange={(e) => setInvoiceData({ ...invoiceData, invoiceDate: e.target.value })}
                  className="w-full border border-gray-300 rounded-lg p-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none bg-gray-50"
                />
              </div>
              <div className="w-1/2">
                <label className="block text-sm font-medium text-gray-700 mb-1">Closing Date</label>
                <input
                  type="date"
                  value={endDate || invoiceData.dueDate}
                  onChange={(e) => setInvoiceData({ ...invoiceData, dueDate: e.target.value })}
                  className="w-full border border-gray-300 rounded-lg p-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none bg-gray-50"
                />
              </div>
            </div>

            {/* Available Invoice Items 
            {availableInvoiceItems.length > 0 && (
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">Quick Add Items</label>
                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-4 rounded-lg border border-blue-200">
                  <div className="flex flex-wrap gap-2">
                    {availableInvoiceItems.map((item, indexxx) => (
                      <button
                        key={indexxx}
                        onClick={() => handleAddPredefinedItem(item)}
                        className="inline-flex items-center px-3 py-1.5 bg-white border border-blue-200 text-blue-700 text-sm rounded-lg hover:bg-blue-50 hover:border-blue-300 transition-colors shadow-sm"
                      >
                        <Plus size={14} className="mr-1" />
                        {item.name} - KSH {item.price}
                        {(item.taxPercentage || item.tax) && (
                          <span className="ml-1 text-xs text-blue-500">({item.taxPercentage || item.tax}% tax)</span>
                        )}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            )}
*/}
            {/* Invoice Items 
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">Invoice Items</label>
              <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                <div className="grid grid-cols-12 gap-2 mb-2 text-xs font-medium text-gray-500 px-2">
                  <div className="col-span-5">DESCRIPTION</div>
                  <div className="col-span-3">AMOUNT (KSH)</div>
                  <div className="col-span-3">TAX (%)</div>
                  <div className="col-span-1"></div>
                </div>

                {invoiceData.items.map((item, indexx) => (
                  <div key={indexx} className="grid grid-cols-12 gap-2 mb-2">
                    <input
                      placeholder="Item description"
                      value={item.description}
                      onChange={(e) => handleItemChange(index, 'description', e.target.value)}
                      className="col-span-5 border border-gray-300 p-2.5 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none bg-white"
                    />
                    <input
                      placeholder="0.00"
                      type="number"
                      step="0.01"
                      value={item.amount}
                      onChange={(e) => handleItemChange(index, 'amount', e.target.value)}
                      className="col-span-3 border border-gray-300 p-2.5 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none bg-white"
                    />
                    <input
                      placeholder="0.0"
                      type="number"
                      step="0.1"
                      value={item.taxPercentage}
                      onChange={(e) => handleItemChange(index, 'taxPercentage', e.target.value)}
                      className="col-span-3 border border-gray-300 p-2.5 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none bg-white"
                    />
                    <button
                      onClick={() => handleRemoveItem(index)}
                      className="col-span-1 flex items-center justify-center text-red-500 hover:text-red-700 hover:bg-red-50 rounded-lg transition-colors"
                    >
                      <X size={16} />
                    </button>
                  </div>
                ))}

                <button
                  onClick={handleAddItem}
                  className="mt-2 text-sm text-indigo-600 hover:text-indigo-800 font-medium flex items-center"
                >
                  <Plus size={16} className="mr-1" /> Add Custom Item
                </button>
              </div>
            </div>
*/}
            {/* Invoice Totals 
            <div className="mb-4">
              <div className="bg-gradient-to-r from-indigo-50 to-violet-50 p-4 rounded-lg border border-indigo-200">
                <h4 className="text-sm font-medium text-gray-700 mb-3">Invoice Summary</h4>
                <div className="space-y-2">
                  <div className="flex justify-between items-center text-sm">
                    <span className="text-gray-600">Subtotal:</span>
                    <span className="font-medium">KSH {totals.subtotal}</span>
                  </div>
                  <div className="flex justify-between items-center text-sm">
                    <span className="text-gray-600">Total Tax:</span>
                    <span className="font-medium">KSH {totals.totalTax}</span>
                  </div>
                  <div className="border-t border-indigo-200 pt-2">
                    <div className="flex justify-between items-center text-base font-semibold">
                      <span className="text-gray-800">Total:</span>
                      <span className="text-indigo-600">KSH {totals.total}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            */}

            {/* Notes */}
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">Notes</label>
              <textarea
                placeholder="Add any additional notes here..."
                value={invoiceData.note}
                onChange={(e) => setInvoiceData({ ...invoiceData, note: e.target.value })}
                className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none bg-gray-50 min-h-20"
              ></textarea>
            </div>

            {/* Action Buttons */}
            <div className="flex justify-end space-x-3">
              <button
                onClick={() => setShowInvoiceModal(false)}
                className="px-4 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 font-medium transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                className="px-6 py-2.5 bg-gradient-to-r from-indigo-600 to-violet-600 text-white rounded-lg hover:from-indigo-700 hover:to-violet-700 font-medium shadow-sm shadow-indigo-200 hover:shadow-md transition-all"
              >
                Generate
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default TopBar;